import axios from "axios";
import qs from "qs";

const defaultConfig = {
  baseURL: process.env.REACT_APP_API_URL,
  paramsSerializer: (params) => qs.stringify(params, { arrayFormat: "repeat" }),
};
// Get the api key and api url from unique id selector
const element = document.getElementById("am-marketplace");
const apikey = element?.getAttribute("apikey");
const apiUrl = element?.getAttribute("apiurl");

export default class ApiService {
  static baseUrl = apiUrl;

  static getConfigs = (additionalConfig = {}) => {
    const config = {
      ...defaultConfig,
      ...additionalConfig,
      headers: {
        "Access-Api-Key": apikey,
      },
    };

    const user = JSON.parse(localStorage.getItem("user"));

    if (user && user.accessToken !== null) {
      config.headers = { ...config.headers, Authorization: user.accessToken };
    }
    return config;
  };

  static get = async (url, params) =>
    axios.get(url, this.getConfigs({ ...params }));

  static post = async function post(url, data) {
    return axios.post(url, data, this.getConfigs());
  };

  static put = async (url, data) => axios.put(url, data, this.getConfigs());

  static patch = async (url, data) => axios.patch(url, data, this.getConfigs());

  static delete = async (url) => axios.delete(url, this.getConfigs());

  static download = async (url) => axios.get(url, this.getConfigs());

  static option = async (url) => axios.options(url, this.getConfigs());

  static upload = async (url, data) => {
    const config = this.getConfigs();
    const formData = new FormData();
    Object.keys(data).forEach((key) => {
      formData.append(key, data[key]);
    });
    config.headers["Content-Type"] = "multipart/form-data";
    return axios.post(url, formData, config);
  };
}
